<template>
  <div class="login">
    <div class="login-form">
      <h1>系统登录</h1>
      <el-tabs v-model="loginType" stretch @tab-click="clearValidation">
        <el-tab-pane label="手机号登录" name="mobile">
          <el-form ref="mobileForm" :rules="mobileRules" :model="mobileForm" style="margin: 0 auto">
            <el-form-item prop="mobile">
              <el-input
                v-model="mobileForm.mobile"
                maxlength="11"
                prefix-icon="el-icon-mobile-phone"
                placeholder="请输入管理员手机号"
              />
            </el-form-item>
            <el-form-item prop="code">
              <div class="code-row">
                <el-input
                  v-model="mobileForm.code"
                  maxlength="6"
                  prefix-icon="el-icon-key"
                  placeholder="请输入验证码"
                  @keyup.enter.native="loginForm"
                />
                <el-button
                  class="code-button"
                  :disabled="countdown > 0"
                  :loading="codeLoading"
                  @click="getCode"
                  >{{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="超级管理员登录" name="password">
          <el-form
            ref="passwordForm"
            :rules="passwordRules"
            :model="passwordForm"
            style="margin: 0 auto"
          >
            <el-form-item prop="username">
              <el-input
                v-model="passwordForm.username"
                prefix-icon="el-icon-user-solid"
                placeholder="请输入用户名"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="passwordForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                @keyup.enter.native="loginForm"
              />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="loginForm"
          :loading="loading"
          style="width: 100%; height: 44px; font-size: 14px; font-weight: bold; letter-spacing: 8px"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { sendLoginCode } from '@/api/login'

export default {
  name: 'Login',
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      loginType: 'mobile',
      mobileForm: {
        mobile: '',
        code: ''
      },
      passwordForm: {
        username: 'admin',
        password: ''
      },
      mobileRules: {
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码' }]
      },
      passwordRules: {
        username: [{ required: true, message: '请输入用户名' }],
        password: [{ required: true, message: '请输入密码' }]
      },
      loading: false,
      codeLoading: false,
      countdown: 0,
      countdownTimer: null
    }
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer)
  },
  methods: {
    clearValidation() {
      this.$nextTick(() => {
        const form = this.$refs[`${this.loginType}Form`]
        if (form) form.clearValidate()
      })
    },
    getCode() {
      this.$refs.mobileForm.validateField('mobile', (error) => {
        if (error) return
        this.codeLoading = true
        sendLoginCode(this.mobileForm.mobile)
          .then(() => {
            this.$message.success('验证码发送成功')
            this.startCountdown()
          })
          .finally(() => {
            this.codeLoading = false
          })
      })
    },
    startCountdown() {
      this.countdown = 60
      if (this.countdownTimer) clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },
    loginForm() {
      const form = this.$refs[`${this.loginType}Form`]
      form.validate((valid) => {
        if (valid) {
          this.loading = true
          const loginData = {
            loginType: this.loginType,
            ...(this.loginType === 'mobile' ? this.mobileForm : this.passwordForm)
          }
          this.$store
            .dispatch('Login', loginData)
            .then(() => {
              this.$router.push({ path: '/' })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 100vh;
  background-color: #2d3a4b;
  &-form {
    width: 400px;
    padding-top: 160px;
    margin: 0 auto;
    h1 {
      color: #eee;
      font-size: 26px;
      text-align: center;
      margin-bottom: 10px;
    }
    .code-row {
      display: flex;
      gap: 10px;
    }
    .code-button {
      width: 126px;
      height: 50px;
      flex-shrink: 0;
    }
  }
}
::v-deep .el-tabs__item {
  color: #c0c4cc;
}
::v-deep .el-tabs__item.is-active {
  color: #409eff;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: rgba(255, 255, 255, 0.1);
}
::v-deep .el-input__inner {
  height: 50px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  color: #fff;
}
</style>
